<template>
  <div>
    <tool-tip style="float: right;" v-on:updateToolTip="updateToolTip($event)" v-if="auth_ratification_tooltip_name"
      :name="auth_ratification_tooltip_name" :description="auth_ratification_tooltip_description" :editable="editable"></tool-tip>

<div class="row" style="justify-content: space-between;">
  
  <div class="col-sm-3">
        <base-button
          v-if="!isPartnerAccount"
          :disabled="isReadOnly || isAuthorized"
          size="sm"
          @click="showDocumentTab"
          class="btn-dark float-left mr-1"
          >Upload Document</base-button
        >
      </div>
      <div class="col-sm-4 ">
      <div v-if="hasSignatureImage"  class="container signature_content_padding_top_small signature_field">
          <div  class="row justify-content-end">
           
          </div>

          <img  class="image_layout" :src="authorizedRatifier.ratifierSignature.view" height="100" />
        </div>
       <span>
        
    </span>  
    </div>
      
      </div>
    </div>

</template>
<script>
import { mapGetters , mapActions } from "vuex";
import { EventBus } from "@/event-bus.js";
import Util from "@/util/util";
import DeleteSignature from "@/components/App/signatures/DeleteSignature.vue";

import toolTip from "../../../Tooltip";
import {

  Button,
} from "element-ui";

export default {
  props: ["isReadOnly"],
  name: "Ratification",
  components: {
    [Button.name]: Button,
    toolTip,
    DeleteSignature
  },
  async mounted() {
    await this.getRatificationStatus(this.$route.params.id);
    await this.getAuthorizedRatifier(this.$route.params.id)
    await this.getAllTooltips()
    this.loadToolTips() 
  },
  data() {
    return {
      auth_ratification_tooltip_description: '',
      auth_ratification_tooltip_name: '',
    };
  },
  computed: {
    ...mapGetters({
      isAuthorized: "orderMetadata/isAuthorized",
      isPartnerAccount: "authentication/isPartnerAccount",
      authorizedRatifier: "authorizedRatifier/authorizedRatifier",
      authorizedRatifierRatificationStatus: "authorizedRatifier/authorizedRatifierAuthorizeStatus",
      toolTips: "tooltip/tooltips",
      editable: "tooltip/editable",


    }),
    hasSignatureImage() {
      return !Util.isNullOrEmpty(this.authorizedRatifier.ratifierSignature);
    },
    getOrderIdFromRoute() {
      return parseInt(this.$route.params.id);
    },
    async reloadData() {
      await this.authorizedRatifierRatificationStatus(this.getOrderIdFromRoute);
          // everywhere is reloading this in the submit
    },
  },
  methods:{
    ...mapActions({
      getAllTooltips: "tooltip/getToolTips",
      getRatificationStatus: "authorizedRatifier/getAuthorizedRatifierAuthorizeStatus",
      getAuthorizedRatifier : "authorizedRatifier/getAuthorizedRatifier"
      
    }),
    showDocumentTab() {
      this.$emit("show-document-tab");
      EventBus.$emit('clicked-from', 'RATIFICATION')
    },
    async loaded() {
      await this.getAuthorizedRatifier(this.$route.params.id)
    },
      loadToolTips() {
      const authRatifierToolTip = this.toolTips.find(e => e.name === "Ratification (Document Upload)")
      if (authRatifierToolTip && authRatifierToolTip.status) {
        this.auth_ratification_tooltip_description = authRatifierToolTip.description ? authRatifierToolTip.description : null
        this.auth_ratification_tooltip_name = authRatifierToolTip.name ? authRatifierToolTip.name : null
      }
      return
    },
   async  updateToolTip(updatedData) {
    await this.getAuthorizedRatifier(this.$route.params.id)
      this.loadToolTips()
    },
  },
};
</script>

